module.exports = __webpack_public_path__ + "static/media/Ubuntu-Medium.d3c3b35e.ttf";